"use client"

import { useSearchParams } from "next/navigation"

export function ReturnToForwardHiddenInput() {
    const searchParams = useSearchParams()
    const returnTo = searchParams?.get("returnTo") ?? null

    if (!returnTo) {
        return null
    } else {
        return <input type="hidden" name="returnTo" value={returnTo} />
    }
}
